import React, { useEffect, useState } from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal, ModalProps } from '../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

interface ShareOptionsModalProps extends ModalProps {
  onClose: () => void;
  onCompareClick: () => void;
  onShareClick: () => void;
}

export const ShareOptionsModal = ({
  onClose,
  onCompareClick,
  onShareClick,
  ...rest
}: ShareOptionsModalProps) => {
  return (
    <Modal size="small" {...rest}>
      <ModalHeader />
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box mt="32">
          <Text fontWeight={600} textAlign="center" fontSize="h3">
            Invite to Compare
          </Text>
          <Text textAlign="center" mt="8">
            See how your financial values align with those of a partner, family member, or friend.
          </Text>
          <Button size="large" mt="16" css="width: 100%;" onClick={onCompareClick}>
            Send an Invite
          </Button>
        </Box>

        <Box my="32">
          <Text textAlign="center" mt="8">
            Know someone who could use some financial help? Invite them to check out BeFi20.
          </Text>

          <Button
            variant="secondary"
            size="large"
            mt="16"
            css="width: 100%;"
            onClick={onShareClick}
          >
            Share BeFi20
          </Button>
        </Box>
      </ModalBody>
    </Modal>
  );
};
